import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-525246b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "container-fluid message-container-align"
}
const _hoisted_3 = {
  key: 1,
  class: "container-fluid message-container-align"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = {
  key: 2,
  class: "container-fluid"
}
const _hoisted_9 = {
  key: 0,
  class: "container"
}
const _hoisted_10 = { href: "" }
const _hoisted_11 = {
  key: 1,
  class: "container"
}
const _hoisted_12 = { href: "" }
const _hoisted_13 = {
  class: "container p-3",
  style: {"min-height":"363px"}
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer20" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer20" }, null, -1))
const _hoisted_18 = {
  id: "previousDownloads",
  class: "txtSize15"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer5" }, null, -1))
const _hoisted_20 = {
  id: "remainingDownloads",
  class: "txtSize15"
}

import { ref, watch, onMounted, computed } from "vue";
import CryptoJS from "crypto-js";
import Recaptcha from "./Recaptcha.vue";
import router from "@/router";
import { useI18n } from "vue-i18n";
import axios from "axios";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { generateChecksum } from "../services/generateChecksum";
import { decryptData } from "../services/decryptData";

export default /*#__PURE__*/_defineComponent({
  __name: 'SubscriberPdfForm',
  setup(__props) {

const otpRequired = ref(false);
const expiryDays = computed(() => userDocument?.value?.ExpiryDays);
const secretKey = process.env.VUE_APP_ENCRYPT_DECRYPT_SECRET_KEY;
const JwtSecretKey = process.env.VUE_APP_JWT_KEY;
const errorFlag = ref(false);
const unAuthorizedFlag = ref(false);
const store = useStore();
const loader = ref(false);
const { t, locale } = useI18n();
const Password = ref("");
const captchaInput = ref("");
const PasswordState = ref<boolean | null>(null);
const captchaState = ref<boolean | null>(null);
const captchaText = ref("");
const captchaError = ref<"empty" | "mismatch" | null>(null);
const PasswordError = ref<"empty" | "mismatch" | null>(null);
const userDocument = ref<any | null>(null);
const invoiceDetail = ref<any | null>(null);
const downloadCount = computed(() => invoiceDetail?.value?.DownloadCount);
const remainingDownloads = computed(
  () => userDocument?.value?.MaxDownloads - invoiceDetail?.value?.DownloadCount
);
//const linkExpiredFlag = ref(false);
const invalidIDFlag = ref(false);
const baseUrl = process.env.VUE_APP_BASE_API_URL;
const handleCaptchaUpdate = (text: string) => {
  captchaText.value = text;
};
const key = CryptoJS.enc.Utf8.parse(process.env.VUE_APP_AES_KEY);
const hashPhoneNumber = (password: string) => {
  const encrypted = CryptoJS.AES.encrypt(password, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString();
};
const showPassword = ref(true);
const togglePasswordVisibility = () => {
  showPassword.value = !showPassword.value;
};
const route = useRoute();
const userId = ref(route.query.p as string);
const maxPasswordExceeded = ref(false);

const getInvoiceCount = async (token: any) => {
  const checksumString = `${userId.value}`;
  const checksum = generateChecksum(checksumString);
  try {
    const invoiceCountDetail = await axios.get(
      `${baseUrl}/invoice/count/${userId.value}`,
      {
        headers: { Authorization: `Bearer ${token}`, "X-Checksum": checksum },
      }
    );
    const encryptedData = invoiceCountDetail.data;
    const decryptedText = decryptData(encryptedData);
    const receivedChecksum = invoiceCountDetail.headers["x-file-checksum"];
    const calculatedChecksum = generateChecksum(invoiceCountDetail.data);
    const invoiceData = JSON.parse(decryptedText);
    if (
      receivedChecksum === calculatedChecksum &&
      invoiceData.UserId === userId.value &&
      invoiceData.IsLocked == false
    ) {
      invoiceDetail.value = invoiceData;
      loader.value = false;
    } else {
      loader.value = false;
      errorFlag.value = true;
    }
  } catch (error: any) {
    loader.value = false;
    errorFlag.value = true;
    console.error("Failed to fetch invoice details:", error);
  }
};
const getToken = async (token: any) => {
  token = "";
  try {
    const encryptedDataValue = {
      UserId: userId.value,
      SecretKey: JwtSecretKey,
      timestamp: new Date().toISOString(),
    };
    const checksumString = Object.values(encryptedDataValue).join("-");
    const checksum = generateChecksum(checksumString);
    const dataString = JSON.stringify(encryptedDataValue);
    const encryptedDataString = CryptoJS.AES.encrypt(
      dataString,
      secretKey
    ).toString();
    const tokenResponse = await axios.post(
      `${baseUrl}/auth/generate-token`,
      { encryptedDataString },
      {
        headers: {
          "Content-Type": "application/json",
          "X-Checksum": checksum,
        },
      }
    );
    token = tokenResponse.data.token;
    setTokenInSessionStorage(token, 23);
    return token;
  } catch (error: any) {
    console.error("Failed to generate token:", error);
    if (error.response) {
      if (error.response.status === 404 || error.response.status === 401) {
        unAuthorizedFlag.value = true;
      } else {
        errorFlag.value = true;
        throw new Error("Failed to generate token. Please try again.");
      }
    }
  }
};
const invalidPasswordAttemptCount = async () => {
  let token = getTokenFromSessionStorage();

  if (!token) {
    token = await getToken(token);
  }
  if (
    invoiceDetail?.value?.InvalidPasswordAttempts + 1 >
    process.env.VUE_APP_MAX_PASSWORD_ATTEMPT_ALLOWED
  ) {
    maxPasswordExceeded.value = true;
  }
  await getInvoiceCount(token);
};

const validateForm = async () => {
  let isValid = true;
  PasswordState.value = null;
  if (!Password.value) {
    PasswordError.value = "empty";
    PasswordState.value = false;
    isValid = false;
  } else {
    PasswordError.value = "";
  }
  captchaState.value = captchaInput.value === captchaText.value;
  if (!captchaInput.value) {
    captchaError.value = "empty";
    captchaState.value = false;
    isValid = false;
  } else if (captchaInput.value !== captchaText.value) {
    captchaError.value = "mismatch";
    captchaState.value = false;
    isValid = false;
  }
  if (captchaError.value === "empty" || captchaError.value === "mismatch") {
    if (!Password.value) {
      PasswordState.value = false;
    } else {
      PasswordState.value = null;
    }
  }
  if (captchaState.value && PasswordState.value !== false) {
    const hashedPhoneNumber = hashPhoneNumber(Password.value);
    let token = getTokenFromSessionStorage();
    if (!token) {
      token = await getToken(token);
    }
    const encryptedDataValue = {
      UserId: userId.value,
      password: hashedPhoneNumber,
      timestamp: new Date().toISOString(),
    };
    const checksumString = Object.values(encryptedDataValue).join("-");
    const checksum = generateChecksum(checksumString);
    const dataString = JSON.stringify(encryptedDataValue);
    const encryptedDataString = CryptoJS.AES.encrypt(
      dataString,
      secretKey
    ).toString();
    const response = await axios.post(
      `${baseUrl}/check-password`,
      { encryptedDataString },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          "X-Checksum": checksum,
        },
      }
    );
    const passwordMatchFlag = ref("");
    const encryptedData = response.data;
    const decryptedText = decryptData(encryptedData);
    const receivedChecksum = response.headers["x-file-checksum"];
    const calculatedChecksum = generateChecksum(response.data);
    const invoiceData = JSON.parse(decryptedText);
    otpRequired.value = invoiceData.OtpRequired;
    if (
      receivedChecksum === calculatedChecksum &&
      invoiceData.UserId === userId.value
    ) {
      passwordMatchFlag.value = invoiceData.Password;
      if (passwordMatchFlag.value) {
        PasswordState.value = true;
        PasswordError.value = "";
      }
      loader.value = false;
    } else {
      loader.value = false;
      errorFlag.value = true;
    }
    if (!passwordMatchFlag.value) {
      PasswordError.value = "mismatch";
      PasswordState.value = false;
      invalidPasswordAttemptCount();
      isValid = false;
    } else {
      PasswordState.value = true;
    }
  }
  if (isValid && captchaState.value && PasswordState.value === true) {
    invalidPasswordAttemptCount();
    store.commit("setUserID", userDocument.value.Id);
    store.commit("setAuth", true);
    setTimeout(() => {
      router.push({ name: "PDFDownloadPage", query: { p: userId.value } });
    }, 300);
  }
  return isValid;
};

watch(Password, () => (PasswordState.value = null));
watch(captchaInput, () => {
  captchaError.value = null;
  captchaState.value = null;
});

const setTokenInSessionStorage = (token: any, expiresIn: number) => {
  const expirationTime = Date.now() + expiresIn * 3600 * 1000;
  sessionStorage.setItem(`token_${userId.value}`, token);
  sessionStorage.setItem(
    `tokenExpiration_${userId.value}`,
    expirationTime.toString()
  );
};

const getTokenFromSessionStorage = () => {
  const token = sessionStorage.getItem(`token_${userId.value}`);
  const expirationTime = parseInt(
    sessionStorage.getItem(`tokenExpiration_${userId.value}`) || "0"
  );

  if (Date.now() > expirationTime) {
    sessionStorage.removeItem(`token_${userId.value}`);
    sessionStorage.removeItem(`tokenExpiration_${userId.value}`);
    return null;
  }

  return token;
};

const fetchUserData = async () => {
  store.commit("setAuth", false);
  try {
    loader.value = true;
    let token = getTokenFromSessionStorage();

    if (!token) {
      token = await getToken(token);
    }
    const checksumString = `${userId.value}`;
    const checksum = generateChecksum(checksumString);
    try {
      const invoiceResponse = await axios.get(
        `${baseUrl}/invoice/${userId.value}`,
        {
          headers: { Authorization: `Bearer ${token}`, "X-Checksum": checksum },
        }
      );
      const encryptedData = invoiceResponse.data;
      const decryptedText = decryptData(encryptedData);
      const receivedChecksum = invoiceResponse.headers["x-file-checksum"];
      const calculatedChecksum = generateChecksum(invoiceResponse.data);
      const invoiceData = JSON.parse(decryptedText);
      if (
        receivedChecksum === calculatedChecksum &&
        invoiceData.UserId === userId.value
      ) {
        userDocument.value = invoiceData;
        store.commit("setSubscriber", !invoiceData.OtpRequired);
        store.commit("setDisplayTitle", true);
      } else {
        loader.value = false;
        errorFlag.value = true;
      }
    } catch (error: any) {
      console.error("Failed to fetch user data", error);
      if (error.response && error.response.status === 404) {
        invalidIDFlag.value = true;
        loader.value = false;
        throw new Error(
          "User ID not found. Please check the ID and try again."
        );
      } else {
        errorFlag.value = true;
        loader.value = false;
        throw new Error("Failed to fetch user data. Please try again later.");
      }
    }
    await getInvoiceCount(token);
    if (
      invoiceDetail?.value?.InvalidPasswordAttempts + 1 >
      process.env.VUE_APP_MAX_PASSWORD_ATTEMPT_ALLOWED
    ) {
      maxPasswordExceeded.value = true;
    }
  } catch (error: any) {
    error.value =
      error.message || "An unexpected error occurred. Please try again later.";
    loader.value = false;
  } finally {
    loader.value = false;
  }
};

onMounted(fetchUserData);

const formLabel = computed(() => {
  return locale.value === "en"
    ? userDocument.value?.PasswordPromptEnglish
    : userDocument.value?.PasswordPromptFrench || "";
});

const formPlaceholder = computed(() => {
  let label = formLabel.value;
  if (label) {
    label = label.replace(/your /i, "").replace(/votre /i, "le ");
  }
  return label || "";
});

const formError = computed(() => {
  if (PasswordError.value === "empty") {
    return t("form.mandatoryError");
  } else if (PasswordError.value === "mismatch") {
    return t("form.incorrectPassword");
  } else {
    return "";
  }
});

const captchaErrorMessage = computed(() => {
  if (captchaError.value === "empty") {
    return t("form.pleaseentercaptcha");
  } else {
    return t("form.captchadoesnotmatch");
  }
});

return (_ctx: any,_cache: any) => {
  const _component_b_navbar_brand = _resolveComponent("b-navbar-brand")!
  const _component_b_navbar = _resolveComponent("b-navbar")!
  const _component_b_spinner = _resolveComponent("b-spinner")!
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_form_invalid_feedback = _resolveComponent("b-form-invalid-feedback")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_b_navbar, {
      toggleable: "",
      type: "light",
      variant: "light",
      class: "p-3"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_b_navbar_brand, { class: "title" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("title")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    (loader.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_b_spinner, {
            style: {"width":"6rem","height":"6rem","color":"#003778"},
            label: "Large Spinner"
          })
        ]))
      : _createCommentVNode("", true),
    (invalidIDFlag.value || maxPasswordExceeded.value || errorFlag.value || unAuthorizedFlag.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (unAuthorizedFlag.value)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_4, _toDisplayString(_unref(t)("form.unauthorized")), 1))
            : _createCommentVNode("", true),
          (maxPasswordExceeded.value)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_5, _toDisplayString(_unref(t)("form.yourlinkhasexpired")), 1))
            : _createCommentVNode("", true),
          (invalidIDFlag.value)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_6, _toDisplayString(_unref(t)("form.invalidrequest")), 1))
            : _createCommentVNode("", true),
          (errorFlag.value && !unAuthorizedFlag.value)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_7, _toDisplayString(_unref(t)("form.unabletoprocesstherequest")), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (
      !loader.value &&
      !invalidIDFlag.value &&
      !maxPasswordExceeded.value &&
      !errorFlag.value &&
      !unAuthorizedFlag.value
    )
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_unref(store).state.isSubscriber)
            ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                _createTextVNode(_toDisplayString(_unref(t)("form.expirydaysmessage")) + " ", 1),
                _createElementVNode("a", _hoisted_10, _toDisplayString(expiryDays.value) + " " + _toDisplayString(_unref(t)("form.days")), 1),
                _createTextVNode(". ")
              ]))
            : _createCommentVNode("", true),
          (!_unref(store).state.isSubscriber)
            ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                _createTextVNode(_toDisplayString(_unref(t)("form.expirydaysmessageInvoice")) + " ", 1),
                _createElementVNode("a", _hoisted_12, _toDisplayString(expiryDays.value) + " " + _toDisplayString(_unref(t)("form.days")), 1),
                _createTextVNode(". ")
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_b_row, { class: "my-1" }, {
              default: _withCtx(() => [
                _createVNode(_component_b_form_group, {
                  label: formLabel.value,
                  "label-for": "password-input",
                  class: "custom-label"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_b_col, {
                      sm: "4",
                      class: "password-input-container"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_b_form_input, {
                          id: "password-input",
                          placeholder: formPlaceholder.value,
                          modelValue: Password.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((Password).value = $event)),
                          type: showPassword.value ? 'password' : 'text',
                          state: PasswordState.value,
                          class: "custom-placeholder",
                          required: ""
                        }, null, 8, ["placeholder", "modelValue", "type", "state"]),
                        _createElementVNode("a", {
                          onClick: togglePasswordVisibility,
                          class: _normalizeClass(["password-toggle-icon", [
                {
                  'error-icon':
                    PasswordState.value === false ||
                    PasswordError.value === 'mismatch' ||
                    PasswordError.value === 'empty',
                },
                { 'eye-icon-align': PasswordState.value === true },
              ]])
                        }, _hoisted_15, 2),
                        _createVNode(_component_b_form_invalid_feedback, { state: PasswordState.value }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(formError.value), 1)
                          ]),
                          _: 1
                        }, 8, ["state"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }),
            _createVNode(_component_b_row, { class: "my-1" }, {
              default: _withCtx(() => [
                _createVNode(_component_b_form_group, {
                  label: _unref(t)('form.captcha'),
                  "label-for": "captcha-input",
                  class: "custom-label"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_b_col, { sm: "4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_b_form_input, {
                          id: "captcha-input",
                          type: "text",
                          placeholder: _unref(t)('form.entercaptcha'),
                          modelValue: captchaInput.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((captchaInput).value = $event)),
                          state: captchaState.value,
                          class: "custom-placeholder",
                          required: ""
                        }, null, 8, ["placeholder", "modelValue", "state"]),
                        (captchaError.value)
                          ? (_openBlock(), _createBlock(_component_b_form_invalid_feedback, {
                              key: 0,
                              state: captchaState.value
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(captchaErrorMessage.value), 1)
                              ]),
                              _: 1
                            }, 8, ["state"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }),
            _createVNode(Recaptcha, { onCaptchaUpdated: handleCaptchaUpdate }),
            _hoisted_16,
            _createVNode(_component_b_button, {
              pill: "",
              class: "custom-button",
              onClick: validateForm
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("form.submit")), 1)
              ]),
              _: 1
            }),
            _hoisted_17,
            _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(t)("download.previousdownloads")) + ": " + _toDisplayString(downloadCount.value), 1),
            _hoisted_19,
            _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(t)("download.remainingdownloads")) + ": " + _toDisplayString(remainingDownloads.value), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})